import {
  Collections,
  readItems,
  getDirectusClient
} from 'app/utility/directus';
import { normalizeFilterParam } from 'app/utility/helpers';
import { IBranchEssential } from 'app/interfaces/branches';

export interface IGetBranchesEssentialsParams {
  specialistSlug?: string | string[];
  serviceSlug?: string | string[];
  filter?: any;
}

export default async function getBranchesEssentials({
  specialistSlug,
  serviceSlug,
  filter = {}
}: IGetBranchesEssentialsParams = {}) {
  try {
    const directusClient = getDirectusClient();
    const collectionName = Collections.Branches;

    const combinedFilter = {
      services: serviceSlug?.length
        ? { service: { slug: { _in: normalizeFilterParam(serviceSlug) } } }
        : undefined,
      specialists: specialistSlug?.length
        ? {
            specialist: { slug: { _in: normalizeFilterParam(specialistSlug) } }
          }
        : undefined,
      ...filter
    };

    const items = await directusClient.request<Directus.BranchEssential[]>(
      readItems(collectionName, {
        filter: combinedFilter,
        fields: ['id', 'name', 'slug', 'address']
      })
    );

    return items as IBranchEssential[];
  } catch (error) {
    console.error(error);
    return [];
  }
}
